var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_394_77293)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_394_77293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2141 10.1571L22.8779 0H20.8248L13.3021 8.81931L7.29364 0H0.363647L9.44955 13.3364L0.363647 23.9877H2.41681L10.361 14.6742L16.7064 23.9877H23.6364L14.2136 10.1571H14.2141ZM11.402 13.4538L10.4814 12.1258L3.15659 1.55881H6.31012L12.2213 10.0867L13.1419 11.4147L20.8258 22.4998H17.6723L11.402 13.4544V13.4538Z",
    fill: "#ffffff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_394_77293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_394_77293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2727,
    height: 24,
    fill: "#ffffff",
    transform: "translate(0.363647)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.4b7c72944e2cc7b7eb5bacfd035a4793.svg";
export { ForwardRef as ReactComponent };